/**
 * Checks if needle appears at start of haystack
 * @param haystack String to search within
 * @param needle String to search for
 * @returns Whether needle appears at start of string
 */
export function startsWith(haystack: string, needle: string): boolean {
  return haystack.indexOf(needle) === 0
}
